import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Icon = ({ d, size = 18, strokeWidth = 2, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    </svg>
);

const icons = {
    eye: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    eyeOff: ['M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24', 'M1 1l22 22'],
    server: ['M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4z', 'M2 14a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4z', 'M6 6h.01', 'M6 16h.01'],
    shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
    mail: ['M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z', 'M22 6l-10 7L2 6'],
    cpu: ['M4 4h16v16H4z', 'M9 9h6v6H9z', 'M9 1v3', 'M15 1v3', 'M9 20v3', 'M15 20v3', 'M20 9h3', 'M20 14h3', 'M1 9h3', 'M1 14h3'],
    settings: ['M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
    send: ['M22 2L11 13', 'M22 2l-7 20-4-9-9-4 20-7z']
};

export default function SMTPSettings({ user }) {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [testing, setTesting] = useState(false);
    const [message, setMessage] = useState(null);
    const [testMessage, setTestMessage] = useState(null);
    const [activeTab, setActiveTab] = useState('settings');
    const [testEmailAddress, setTestEmailAddress] = useState('');

    const [form, setForm] = useState({
        mailEngine: 'PHPMailer',
        emailProtocol: 'SMTP',
        encryption: 'SSL',
        host: '',
        port: 465,
        email: '',
        senderName: '',
        username: '',
        password: '',
        emailTestMode: true,
        testRecipientEmail: 'shravyakotian282@gmail.com',
        charset: 'utf-8',
        bccAllEmailsTo: '',
        emailSignature: '',
        predefinedHeader: '',
        predefinedFooter: ''
    });

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const operatorId = user?.operatorId || (user?._id === user?.operatorId ? user?._id : 'admin');
                const res = await axios.get('/api/smtp-settings', { params: { operatorId } });
                if (res.data) setForm(prev => ({ ...prev, ...res.data }));
            } catch (err) {
                console.error("Failed to load SMTP settings", err);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, [user]);

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setMessage(null);
        try {
            const operatorId = user?.operatorId || (user?._id === user?.operatorId ? user?._id : 'admin');
            const res = await axios.post('/api/smtp-settings', { ...form, operatorId });
            setMessage({ type: 'success', text: res.data.message });
            setTimeout(() => setMessage(null), 5000);
        } catch (err) {
            setMessage({ type: 'error', text: err.response?.data?.message || err.message });
        } finally {
            setSaving(false);
        }
    };

    const handleTestEmail = async (e) => {
        e.preventDefault();
        if (!testEmailAddress) {
            setTestMessage({ type: 'error', text: 'Please enter an email address for testing.' });
            return;
        }
        setTesting(true);
        setTestMessage(null);
        try {
            const operatorId = user?.operatorId || (user?._id === user?.operatorId ? user?._id : 'admin');
            const res = await axios.post('/api/smtp-settings/test', { testEmail: testEmailAddress, operatorId });
            setTestMessage({ type: 'success', text: res.data.message });
        } catch (err) {
            setTestMessage({ type: 'error', text: err.response?.data?.message || err.message });
        } finally {
            setTesting(false);
        }
    };

    if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', color: '#64748b' }}>Loading settings...</div>;

    // UI Components
    const Card = ({ title, icon, children }) => (
        <div style={{ background: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)', overflow: 'hidden', marginBottom: '32px', transition: 'all 0.2s ease' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #f1f5f9', background: '#fafaf9', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ background: '#e6f0fa', padding: '8px', borderRadius: '8px', color: '#16539C', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Icon d={icon} size={20} />
                </div>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#1e293b' }}>{title}</h3>
            </div>
            <div style={{ padding: '24px' }}>
                {children}
            </div>
        </div>
    );

    const InputWrap = ({ label, hint, children }) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label style={{ fontSize: '13px', fontWeight: 600, color: '#334155', display: 'flex', justifyContent: 'space-between' }}>
                {label}
                {hint && <span style={{ color: '#8b5cf6', fontSize: '12px', fontWeight: 500 }}>{hint}</span>}
            </label>
            {children}
        </div>
    );

    const inputStyle = {
        width: '100%', padding: '12px 16px', border: '1.5px solid #e2e8f0', 
        borderRadius: '10px', fontSize: '14px', outline: 'none', background: '#fff', 
        color: '#1e293b', transition: 'all 0.2s ease', boxSizing: 'border-box'
    };
    const focusStyle = "e.target.style.borderColor='#00B2A9'; e.target.style.boxShadow='0 0 0 4px rgba(99, 102, 241, 0.1)'";
    const blurStyle = "e.target.style.borderColor='#e2e8f0'; e.target.style.boxShadow='none'";

    const radioCardStyle = (isActive) => ({
        display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', 
        borderRadius: '10px', border: `1.5px solid ${isActive ? '#00B2A9' : '#e2e8f0'}`, 
        background: isActive ? '#eef2ff' : '#fff', cursor: 'pointer', transition: 'all 0.2s ease', flex: 1
    });

    return (
        <div style={{ background: '#f8fafc', minHeight: '100vh', padding: '40px 24px', fontFamily: "'Inter', sans-serif" }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                
                {/* Header Area */}
                <div className="superadmin-page-header">
                <div className="header-titles">
                    <h1>Email Infrastructure</h1>
                    <p>Configure your primary mailing engine and delivery protocols.</p>
                </div>
                <div className="header-actions">
                    
                    {/* Modern Tabs */}
                    <div style={{ display: 'flex', background: '#fff', padding: '6px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                        <button 
                            onClick={() => setActiveTab('settings')}
                            style={{ padding: '8px 24px', borderRadius: '8px', border: 'none', background: activeTab === 'settings' ? '#00B2A9' : 'transparent', color: activeTab === 'settings' ? '#fff' : '#64748b', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s' }}
                        >
                            Configuration
                        </button>
                        <button 
                            onClick={() => setActiveTab('queue')}
                            style={{ padding: '8px 24px', borderRadius: '8px', border: 'none', background: activeTab === 'queue' ? '#00B2A9' : 'transparent', color: activeTab === 'queue' ? '#fff' : '#64748b', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s' }}
                        >
                            Live Queue
                        </button>
                    
                </div>
            </div>
                </div>

                {message && (
                    <div style={{ padding: '16px 20px', borderRadius: '12px', marginBottom: '32px', backgroundColor: message.type === 'success' ? '#ecfdf5' : '#fef2f2', color: message.type === 'success' ? '#065f46' : '#991b1b', border: `1px solid ${message.type === 'success' ? '#a7f3d0' : '#fecaca'}`, display: 'flex', alignItems: 'center', gap: '12px', fontWeight: 500 }}>
                        <div style={{ background: message.type === 'success' ? '#34d399' : '#f87171', color: '#fff', borderRadius: '50%', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {message.type === 'success' ? '✓' : '!'}
                        </div>
                        {message.text}
                    </div>
                )}

                {activeTab === 'settings' ? (
                    <form onSubmit={handleSave}>
                        


                        <Card title="Content & Formatting" icon={icons.settings}>
                            <div style={{ display: 'grid', gap: '24px' }}>
                                <InputWrap label="Default Signature">
                                    <textarea value={form.emailSignature} onChange={e => setForm({...form, emailSignature: e.target.value})} rows={3} placeholder="Kind regards,&#10;The Opsmaticz Team" style={{ ...inputStyle, resize: 'vertical' }} onFocus={(e) => eval(focusStyle)} onBlur={(e) => eval(blurStyle)} />
                                </InputWrap>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
                                    <InputWrap label="HTML Header Wrapper">
                                        <textarea value={form.predefinedHeader} onChange={e => setForm({...form, predefinedHeader: e.target.value})} rows={4} placeholder="<div class='header'>...</div>" style={{ ...inputStyle, resize: 'vertical', fontFamily: 'monospace', fontSize: '13px' }} onFocus={(e) => eval(focusStyle)} onBlur={(e) => eval(blurStyle)} />
                                    </InputWrap>

                                    <InputWrap label="HTML Footer Wrapper">
                                        <textarea value={form.predefinedFooter} onChange={e => setForm({...form, predefinedFooter: e.target.value})} rows={4} placeholder="<div class='footer'>...</div>" style={{ ...inputStyle, resize: 'vertical', fontFamily: 'monospace', fontSize: '13px' }} onFocus={(e) => eval(focusStyle)} onBlur={(e) => eval(blurStyle)} />
                                    </InputWrap>
                                </div>
                            </div>
                        </Card>

                        {/* Testing Mode & Sticky Submit */}
                        <div style={{ background: '#fff', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', position: 'sticky', bottom: '24px', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '24px' }}>
                            
                            <div style={{ flex: 1, minWidth: '300px' }}>
                                <h3 style={{ margin: '0 0 12px 0', fontSize: '15px', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: form.emailTestMode ? '#f59e0b' : '#10b981' }}></div>
                                    Environment Routing
                                </h3>
                                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                        <div style={{ width: 44, height: 24, background: form.emailTestMode ? '#f59e0b' : '#cbd5e1', borderRadius: '24px', position: 'relative', transition: 'all 0.3s' }}>
                                            <div style={{ width: 18, height: 18, background: '#fff', borderRadius: '50%', position: 'absolute', top: 3, left: form.emailTestMode ? 23 : 3, transition: 'all 0.3s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' }}></div>
                                            <input type="checkbox" checked={form.emailTestMode} onChange={(e) => setForm({...form, emailTestMode: e.target.checked})} style={{ opacity: 0, width: 0, height: 0 }} />
                                        </div>
                                        <span style={{ fontSize: '14px', fontWeight: 600, color: form.emailTestMode ? '#b45309' : '#64748b' }}>Test Sandbox</span>
                                    </label>
                                    
                                    {form.emailTestMode && (
                                        <input type="email" value={form.testRecipientEmail} onChange={e => setForm({...form, testRecipientEmail: e.target.value})} placeholder="Trap address (e.g. me@example.com)" style={{ padding: '8px 16px', borderRadius: '8px', border: '1.5px solid #fcd34d', background: '#fffbeb', color: '#92400e', fontSize: '13px', outline: 'none', width: '250px' }} />
                                    )}
                                </div>
                            </div>

                            <button type="submit" disabled={saving} style={{ background: '#16539C', color: '#fff', padding: '14px 40px', borderRadius: '10px', border: 'none', fontSize: '15px', fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1, transition: 'all 0.2s', boxShadow: '0 4px 12px rgba(22, 83, 156, 0.3)' }}>
                                {saving ? 'Applying...' : 'Deploy Configuration'}
                            </button>
                        </div>
                    </form>
                ) : (
                    <div style={{ background: '#fff', padding: '60px', borderRadius: '16px', border: '1px dashed #cbd5e1', textAlign: 'center' }}>
                        <div style={{ color: '#94a3b8', marginBottom: '16px' }}><Icon d={icons.mail} size={48} strokeWidth={1} /></div>
                        <h2 style={{ color: '#1e293b', fontSize: '20px', margin: '0 0 8px 0' }}>Queue is Empty</h2>
                        <p style={{ color: '#64748b', fontSize: '15px' }}>Live queue monitoring will appear here.</p>
                    </div>
                )}

                {/* Diagnostics Panel */}
                {activeTab === 'settings' && (
                    <div style={{ marginTop: '48px', padding: '32px', background: '#1e293b', borderRadius: '16px', color: '#fff', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <div style={{ background: 'rgba(255,255,255,0.1)', padding: '8px', borderRadius: '8px' }}>
                                <Icon d={icons.send} size={20} color="#60a5fa" />
                            </div>
                            <h2 style={{ fontSize: '20px', margin: 0, fontWeight: 700 }}>Diagnostics</h2>
                        </div>
                        <p style={{ color: '#94a3b8', fontSize: '15px', margin: '0 0 24px 0', marginLeft: '48px' }}>Send a synthetic payload to verify your engine connection.</p>

                        {testMessage && (
                            <div style={{ padding: '12px 16px', borderRadius: '8px', marginBottom: '24px', backgroundColor: testMessage.type === 'success' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)', color: testMessage.type === 'success' ? '#34d399' : '#f87171', border: `1px solid ${testMessage.type === 'success' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`, fontSize: '14px' }}>
                                {testMessage.text}
                            </div>
                        )}

                        <form onSubmit={handleTestEmail} style={{ display: 'flex', gap: '16px', marginLeft: '48px' }}>
                            <input 
                                type="email" 
                                value={testEmailAddress} 
                                onChange={e => setTestEmailAddress(e.target.value)} 
                                placeholder="Recipient address for diagnostics..." 
                                style={{ flex: 1, padding: '14px 20px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(0,0,0,0.2)', color: '#fff', fontSize: '14px', outline: 'none' }} 
                                required
                            />
                            <button type="submit" disabled={testing} style={{ background: '#3b82f6', color: '#fff', padding: '0 32px', borderRadius: '10px', border: 'none', fontSize: '15px', fontWeight: 600, cursor: testing ? 'not-allowed' : 'pointer', opacity: testing ? 0.7 : 1, transition: 'all 0.2s' }}>
                                {testing ? 'Transmitting...' : 'Ping Server'}
                            </button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
}
